import React, { Component, createRef } from 'react';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';

class EnvelopePrint extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.despatchServices = new DespatchServices();
        this.state = {
            partyDropdownList: [],
            envelopDetails: {
                partyId: "",
                partyName: "",
                addressText: "",
                address: "general",
                size: "small",
            },

        };
    }

    componentDidMount() {
        this.getAllPartyDropdown()
    }

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    email: item.email,
                    transporterName: item.transporterName
                }));
                this.setState({ partyDropdownList: dropdownItems }, () => {

                });
            } else {

                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    resetform = () => {
        let envelopDetails = this.state.envelopDetails
        envelopDetails.partyId = ""
        envelopDetails.addressText = ""
        envelopDetails.address = ""
        envelopDetails.size = ""
        this.setState({ envelopDetails: envelopDetails })
    }

    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.envelopDetails;
        details[drpIdentity] = selected.value;
        details.partyName = selected.label
        this.setState({ envelopDetails: details }, () => {
            this.getCompanyAddressByCompanyId(this.state.envelopDetails.partyId)
        });
    };

    getCompanyAddressByCompanyId = (id) => {
        this.despatchServices.getCompanyAddressByCompanyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let addressParts = [
                    "To,",
                    this.state.envelopDetails.partyName,
                    res.address1,
                    res.address2,
                    res.address3 ? `${res.address3},` : "",
                    res.address4 ? `${res.address4},` : "",
                    `${res.city}, ${res.pinCode},`,
                    res.state,
                    `TELEPHONE : ${res.telephone}`
                ];

                let addressPartsForCorrospondence = [
                    "To,",
                    this.state.envelopDetails.partyName,
                    res.corrspAddress1 ? `${res.corrspAddress1},` : "",
                    res.corrspAddress2 ? `${res.corrspAddress2},` : "",
                    res.corrspAddress3 ? `${res.corrspAddress3},` : "",
                    res.corrspAddress4 ? `${res.corrspAddress4},` : "",
                    `${res.city}, ${res.pinCode},`,
                    res.state,
                    `TELEPHONE : ${res.telephone}`
                ];

                let address = addressParts.filter(Boolean).join("\n");
                let addressForCorrospondence = addressPartsForCorrospondence.filter(Boolean).join("\n");

                let details = this.state.envelopDetails
                if (details.address === 'general') {
                    details.addressText = address
                } else {
                    details.addressText = addressForCorrospondence
                }
                this.setState({ envelopDetails: details })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.envelopDetails
        details[name] = value
        this.setState({ envelopDetails: details },
        );
    };
    handleRadioButtonChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.envelopDetails;
        details[name] = value;
        this.setState({ envelopDetails: details }, () => {
            this.getCompanyAddressByCompanyId(this.state.envelopDetails.partyId)
        })

    };

    handlePrint = () => {
        const printContent = this.printRef.current;
        const originalContent = document.body.innerHTML;

        document.body.innerHTML = printContent.innerHTML;
        window.print();

        document.body.innerHTML = originalContent;
        window.location.reload();
    };

    render() {
        return (
            <div className='envelopePrint-page'>
                <div className="item-search">

                    <div className="input-grp w-[50%] mb-3">
                        <label>Party Name</label>
                        <MultiSelectDropdown
                            drpIdentity="partyId"
                            options={this.state.partyDropdownList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                this.setFilterParameters(selected, "partyId")
                            }
                            allowSelectAll={false}
                            value={this.state.partyDropdownList.filter(
                                (party) =>
                                    party.value === this.state.envelopDetails.partyId
                            )}
                        />
                    </div>



                    <div className='mb-3 w-fit'>
                        <div className="input-grp mb-1.5 flex">
                            <div style={{ fontSize: "16.3px", fontWeight: "600", marginRight: "10px" }}>
                                Address :
                            </div>

                            <div className="input-grp  flex items-end mr-2.5">
                                <input
                                    className="mr-[5px] !w-[16px] h-[16px] mb-[2px]"
                                    type="radio"
                                    name="general"
                                    id="general"
                                    autocomplete="off"
                                    value="general"
                                    checked={this.state.envelopDetails.address === "general"}
                                    onChange={(event) => this.handleRadioButtonChange(event, "address")}
                                />
                                <label className='!mb-0'>General</label>
                            </div>
                            <div className="input-grp flex items-end">
                                <input
                                    className="mr-[5px] !w-[16px] h-[16px] mb-[2px]"
                                    type="radio"
                                    name="corrospodence"
                                    id="corrospodence"
                                    autocomplete="off"
                                    value="corrospodence"
                                    checked={this.state.envelopDetails.address === "corrospodence"}
                                    onChange={(event) => this.handleRadioButtonChange(event, "address")}
                                />
                                <label className='!mb-0'>Corrospodence</label>
                            </div>


                        </div>
                        <div className="input-grp  flex">
                            <div style={{ fontSize: "16.3px", fontWeight: "600", marginRight: "10px" }}>
                                Envelope Size :
                            </div>

                            <div className="input-grp flex items-end mr-2.5">
                                <input
                                    className="mr-[5px] !w-[16px] h-[16px] mb-[2px]"
                                    type="radio"
                                    name="big"
                                    id="big"
                                    autocomplete="off"
                                    value="big"
                                    checked={this.state.envelopDetails.size === "big"}
                                    onChange={(event) => this.handleRadioButtonChange(event, "size")}
                                />
                                <label className='!mb-0'>Big</label>
                            </div>

                            <div className="input-grp flex items-end">
                                <input
                                    className="mr-[5px] !w-[16px] h-[16px] mb-[2px]"
                                    type="radio"
                                    name="small"
                                    id="small"
                                    autocomplete="off"
                                    value="small"
                                    checked={this.state.envelopDetails.size === "small"}
                                    onChange={(event) => this.handleRadioButtonChange(event, "size")}
                                />
                                <label className='!mb-0'>Small</label>
                            </div>

                        </div>
                    </div>
                    <div className="item-search-box w-full mb-3">
                        <label>Address</label>
                        <textarea rows="10"
                            name="addressText"
                            id="addressText"
                            autocomplete="off"
                            value={this.state.envelopDetails.addressText}
                            onChange={(event) =>
                                this.handleChange(event, "addressText")
                            }></textarea>
                    </div>

                    <div
                        ref={this.printRef}
                        className="hidden print:block envelope w-[4.33in] h-[8.66in] flex justify-center items-center border border-black print:border-0 relative"
                    >
                        <div  className="text-[14px] text-left whitespace-pre-line absolute left-[170px] rotate-90">
                            {this.state.envelopDetails.addressText}
                        </div>
                    </div>

                    <div className="btn-grp">
                        <button className="cancel-btn" onClick={() => this.resetform()}>
                            Cancel
                        </button>
                        {this.state.envelopDetails.addressText !== "" ?
                            <button
                                className="print-btn"
                                onClick={() => this.handlePrint()}
                            >
                                Print
                            </button> : null}

                    </div>

                </div>
            </div>
        );
    }
}

export default EnvelopePrint;